module.exports = __webpack_public_path__ + "655320ab24b66bc10f3566c3a99d2eef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/unis_logo_black.svg
// module id = 232
// module chunks = 0